var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":"container"}},[(!_vm.previewing)?_c('ts-preview-pdf',{attrs:{"src":_vm.src}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }